import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Download, Clapperboard } from "lucide-react";

const B = process.env.REACT_APP_BACKEND_URL;

export default function AdvertScenes() {
  const [scenes, setScenes] = useState([]);
  const [flyers, setFlyers] = useState([]);
  useEffect(() => {
    fetch(`${B}/api/marketing/kit/public/scenes`).then((r) => r.json()).then((d) => setScenes(d.scenes || [])).catch(() => setScenes([]));
    fetch(`${B}/api/marketing/kit/public/flyers`).then((r) => r.json()).then((d) => setFlyers(d.items || [])).catch(() => setFlyers([]));
  }, []);
  return (
    <div className="max-w-6xl mx-auto px-6 lg:px-10 py-10" data-testid="advert-scenes-page">
      <div className="flex items-center gap-2"><Clapperboard className="h-5 w-5 text-[#FF3B30]" /><h1 className="font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl">Advert scenes</h1></div>
      <p className="mt-3 text-neutral-400 text-base md:text-lg max-w-2xl">The eight AI-generated cinematic scenes behind the hero advert — each in a vertical take (phones) and a widescreen take (TV, laptop, YouTube). <span className="text-[#FF9F0A]">These raw scenes are silent by design</span> — the voice-over and orchestral score are mixed into the final adverts linked below.</p>
      <div className="mt-4 flex flex-wrap gap-3 text-sm">
        <a href={`${B}/api/marketing/kit/public/advert?format=9x16`} className="underline text-neutral-300 hover:text-white" data-testid="scenes-final-9x16">Final advert · vertical 9:16</a>
        <a href={`${B}/api/marketing/kit/public/advert?format=16x9`} className="underline text-neutral-300 hover:text-white" data-testid="scenes-final-16x9">Final advert · widescreen 16:9</a>
        <Link to="/join" className="underline text-neutral-300 hover:text-white" data-testid="scenes-join-link">See it on the Join page</Link>
      </div>
      {flyers.length > 0 && (
        <section className="mt-10" data-testid="flyers-section">
          <h2 className="font-bold text-base md:text-lg text-white">Flyers — "Let's put the whole theatre into your pocket"</h2>
          <div className="mt-4 grid sm:grid-cols-3 gap-5">
            {flyers.map((f) => (
              <div key={f.id} data-testid={`flyer-${f.format}`}>
                <img src={`${B}${f.image_url}`} alt={f.title} className="w-full rounded-xl border border-white/10" />
                <div className="mt-2 flex items-center justify-between text-xs text-neutral-500">
                  <span>{f.width}×{f.height}</span>
                  <a href={`${B}${f.image_url}?download=1`} className="inline-flex items-center gap-1 text-neutral-300 hover:text-white"><Download className="h-3.5 w-3.5" /> Download</a>
                </div>
              </div>
            ))}
          </div>
        </section>
      )}
      <div className="mt-8 space-y-10">
        {scenes.map((s) => (
          <section key={s.key} className="rounded-2xl border border-white/10 bg-[#121212] p-5" data-testid={`scene-${s.key}`}>
            <h2 className="font-bold text-base md:text-lg text-white">{s.title}</h2>
            <div className="mt-4 grid md:grid-cols-[260px_1fr] gap-5 items-start">
              {["9x16", "16x9"].map((f) => s[f] ? (
                <div key={f}>
                  <video src={`${B}${s[f].url}`} controls playsInline preload="metadata" className={`rounded-xl bg-black w-full ${f === "9x16" ? "aspect-[9/16]" : "aspect-video"}`} data-testid={`scene-${s.key}-${f}`} />
                  <div className="mt-2 flex items-center justify-between text-xs text-neutral-500">
                    <span>{f === "9x16" ? "Vertical · phones" : "Widescreen · large screens"} · {(s[f].size / 1048576).toFixed(1)} MB</span>
                    <a href={`${B}${s[f].url}`} download className="inline-flex items-center gap-1 text-neutral-300 hover:text-white"><Download className="h-3.5 w-3.5" /> Download</a>
                  </div>
                </div>
              ) : <div key={f} className="text-xs text-neutral-600 self-center">Widescreen take rendering…</div>)}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
